export default __webpack_public_path__ + "static/article-renovation-luxe-look-a9890cfdd54596daaa05187824fe9c37.jpg";